import React from "react";

const RemoteAreaIcon = (props) => {
  return (
    <div>
      <svg
        fill={props?.color ?? "black"}
        version="1.1"
        id="Capa_1"
        width="24px"
        height="24px"
        viewBox="0 0 30.621 30.621"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <g>
            <g>
              <path d="M0,28.741h30.621v-7.655C9.888,19.427,0,28.741,0,28.741z"></path>
              <path d="M23.109,15.828v-4.923c0.945,0.138,1.676,0.791,1.676-1.467c0-2.481-1.963-7.558-1.963-7.558s-1.965,5.076-1.965,7.558 c0,2.295,0.756,1.583,1.725,1.461v4.97c-1.252,0.122-2.482,0.308-3.689,0.536v-6.08l0.145,0.106 c0.109,0.084,0.238,0.123,0.369,0.123c0.186,0,0.369-0.085,0.488-0.246c0.205-0.271,0.15-0.656-0.119-0.86L18.32,8.356 c0.002-0.02,0.008-0.044,0.008-0.065V7.27c0-0.342-0.277-0.615-0.615-0.615c-0.34,0-0.615,0.273-0.615,0.615v0.172L15.68,6.379 c-0.217-0.163-0.518-0.163-0.736,0l-4.096,3.07c-0.271,0.204-0.325,0.59-0.12,0.86c0.203,0.272,0.587,0.325,0.859,0.123 l0.143-0.106v3.556C6.069,10.941,0,11.792,0,11.792v3.406c0,0,8.186-1.773,15.746,1.613c-0.941-0.947-1.956-1.707-2.994-2.345 V9.555l2.558-1.918l2.559,1.919v7.048C11.294,18.021,5.687,20.774,3,22.554c6.062-1.849,17.351-5.74,27.621-3.255v-3.251 C28.115,15.651,25.582,15.624,23.109,15.828z"></path>{" "}
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default RemoteAreaIcon;
